import create from "zustand";
import { produce } from "immer";

import { GlobalEventManager, FLOW_EVENTS } from "../utils/event/index.js";
import { useGlobalStore } from "../stores/index.js";
import { LEFTNAV_ACTION } from "../../constants/index.js";

// eslint-disable-next-line kf/const-naming-convention
const store = {
  favouritesList: [],
  recentFavourite: {}
};
const createWithImmer = (storeCreator) =>
  create((originalSet, originalGet) =>
    storeCreator((fn) => originalSet(produce(fn)), originalGet)
  );

export const useFavouriteStore = createWithImmer((setState, getState) => ({
  ...store,
  setFavouriteList: (favouriteData) => {
    setState((state) => {
      return { favouritesList: favouriteData };
    });
  },
  addNewFavourites: (newFavourite) => {
    const existingIndex = getState().favouritesList.findIndex(
      (data) => data._id === newFavourite._id
    );
    if (existingIndex < 0) {
      const FavoritedAt = new Date().toISOString();
      GlobalEventManager.dispatchEvent(FLOW_EVENTS.FAVORITE, {
        payload: { ...newFavourite, FavoritedAt }
      });
      useGlobalStore
        .getState()
        .syncLeftNav(LEFTNAV_ACTION.UPDATE, { ...newFavourite, FavoritedAt });
      setState((state) => {
        return {
          favouritesList: [
            { ...newFavourite, FavoritedAt },
            ...getState().favouritesList
          ],
          recentFavourite: {
            ...newFavourite,
            FavoritedAt
          }
        };
      });
    }
  },
  updateFavourites: (updatedFavourite) => {
    const newFavouriteList = getState().favouritesList.map((data) => {
      if (data._id === updatedFavourite._id) {
        return { ...data, ...updatedFavourite };
      }
      return data;
    });
    if (newFavouriteList) {
      setState((state) => {
        return {
          favouritesList: newFavouriteList
        };
      });
    }
  },
  removeExistingFavourites: (removeData) => {
    let isExist = false;
    const newFavouriteList = getState().favouritesList.filter((data) => {
      if (data._id === removeData._id) {
        isExist = true;
        return false;
      }
      return true;
    });
    if (isExist) {
      useGlobalStore.getState().syncLeftNav(LEFTNAV_ACTION.UPDATE, {
        ...removeData,
        FavoritedAt: null
      });
      GlobalEventManager.dispatchEvent(FLOW_EVENTS.UNFAVORITE, {
        payload: removeData
      });
      setState((state) => {
        return {
          favouritesList: newFavouriteList,
          recentFavourite: {
            ...removeData,
            FavoritedAt: null
          }
        };
      });
    }
  },
  reset: (data) => {
    setState((state) => {
      return { ...store };
    });
  }
}));
